<template>
  <div class="bizAIIcon">
    <OpenBubbleChat :color="color || undefined"/>
    <Star class="star-rotate" :color="color || undefined"/>
  </div>
</template>
<script>
export default {
  name: 'BizAiIcon',
  components: {
    Star: () => import('@/modules/bizai/assets/star.svg'),
    OpenBubbleChat: () => import('@/modules/bizai/assets/open-bubble-chat.svg'),
  },
  props: {
    color: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped lang="scss">
.bizAIIcon {
  color: var(--gray-darken-5);
  width: 100%;
  height: 100%;
}

.star-rotate {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  animation-delay: 3s;
  animation-duration: 8s;
  animation-iteration-count: 8;
  animation-timing-function: linear;
  animation-name: star-rotate;
  transform-origin: 80%;
  transform: rotateY(0deg) translateX(1px);
}

@keyframes star-rotate {
  0% {
    transform: rotateY(0deg) translateX(1px);
  }
  7% {
    transform: rotateY(180deg) translateX(1px);
  }
  14% {
    transform: rotateY(0deg) translateX(1px);
  }
  100% {
    transform: rotateY(0deg) translateX(1px);
  }
}
</style>
